import $ from 'jquery';

class Chapters {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$navLinks = $('.chapters__nav-link');
        this.$navLinks.on('click', e => this.activateChapter(e));
    }

    activateChapter(e) {
        this.$navLinks.removeClass('active');
        $(e.currentTarget).addClass('active');
        let index = $(e.currentTarget).index() + 1;
        let aTag = $(`a[name="chapter-${index}"]`);
        $('html,body').animate({ scrollTop: aTag.offset().top - 40 }, '300');
    }

    static init() {
        if ($('.chapters').length > 0) {
            new Chapters();
        }
    }
}

export default Chapters;
